import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function ClosingCTASection() {
  const scrollToCheckout = () => {
    document.getElementById('checkout')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-green-900/20 via-black to-black text-center" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <div className="space-y-4 mb-12 text-2xl sm:text-4xl font-bold text-white" data-id="element-70">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-71">
            Sientes control.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-72">
            Sientes calma.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} viewport={{
          once: true
        }} className="text-green-500" data-id="element-73">
            Sientes independencia.
          </motion.p>
        </div>

        <Button size="xl" onClick={scrollToCheckout} className="w-full sm:w-auto group shadow-[0_0_40px_rgba(34,197,94,0.3)]" data-id="element-74">
          QUIERO MI HUERTA 360° AHORA
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-75" />
        </Button>
      </div>
    </section>;
}